import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Form from "../../common/forms/Form";
import FormInput from "../../common/forms/FormInput";
import AgreementCheckBox from "../../common/forms/AgreementCheckBox";
import LoadingSpinner from "../../common/LoadingSpinner";

import styles from "./offermodal.module.scss";
import { OfferRequestState } from "./OfferModalContainer";
import RequestCompleteModalBody from "../../common/settings-modal/RequestCompleteModalBody";

type Props = {
  ownerName: string;
  ownerChatDenial: boolean;
  invalidReason: boolean;
  handleClose: () => void;
  handleSubmit: () => void;
  handleInputChange: (value: string | undefined, name: string) => void;
  offerRequestState: OfferRequestState;
};

export const OfferModal: React.FC<Props> = ({
  ownerName,
  ownerChatDenial,
  invalidReason,
  handleClose,
  handleSubmit,
  handleInputChange,
  offerRequestState,
}) => {
  const [isAgreement, setIsAgreement] = useState<boolean>(false);
  return (
    <div className={styles["offermodal"]}>
      <div className={styles["offermodal__box"]}>
        {offerRequestState === OfferRequestState.Doing ? (
          <LoadingSpinner space={1} />
        ) : offerRequestState === OfferRequestState.Waiting ? (
          <>
            <div className={styles["offermodal-head"]}>
              <h1>オファー</h1>
              <i
                className={styles["offermodal-head__modal-close"]}
                onClick={handleClose}
              >
                <FontAwesomeIcon icon={["fas", "times"]} />
              </i>
            </div>
            <Form
              button_id="offer"
              button_text="オファーする"
              button_class={
                isAgreement
                  ? styles["offerbutton"]
                  : `${styles["offerbutton"]} ${styles["disabled"]}`
              }
              handler={() => {
                if (isAgreement) handleSubmit();
              }}
              className={styles["offer-form"]}
              disabled={!isAgreement}
            >
              <div className={styles["offer-form-desc"]}>
                『オファーする』ボタンを押すと、SELeCT運営にオファー依頼が送信されます。
                <br />
                依頼後の手続きや結果に関してはマイページ、またはメールでご連絡致します。
                <br />
                オファー後にオファー相手とチャットを開始できます。
              </div>
              <div className={styles["offer-form-user"]}>
                <div>オファー先会員名</div>
                <FontAwesomeIcon icon={["fas", "user"]} />
                {ownerName}
                {ownerChatDenial && (
                  <p>
                    このユーザーとは現在チャットはできません。
                    <br />
                    やり取りはSELeCT運営を介して行えます。
                  </p>
                )}
              </div>
              <h2 className={styles["offer-form-h2"]}>
                オファー内容を選択してください
              </h2>
              <div className={styles["offer-form-input"]}>
                <FormInput
                  type="select"
                  name="sonic_type"
                  label=""
                  label_class={styles["offer-form-input-label"]}
                  select_class={styles["offer-form-input-select"]}
                  holder_class={styles["offer-form-input-select-holder"]}
                  options={[
                    ["", "オファー内容を選択"],
                    ["0", "キャスティング依頼をしたい"],
                    // ["1", "出演依頼をしたい"],
                    ["2", "イベントを開催したい"],
                    ["3", "チームを作りたい"],
                    ["4", "スポンサー契約を結びたい"],
                    ["5", "その他"],
                  ]}
                  handler={handleInputChange}
                />
                <FontAwesomeIcon icon={["fal", "chevron-down"]} />
              </div>
              <div className={styles["other-offer"]}>
                {invalidReason === true ? (
                  <p className={styles["error"]}>内容を入力してください</p>
                ) : null}
                <p className={styles["remarks"]}>
                  その他を選択した方は以下に内容をご入力ください
                </p>
                <FormInput
                  type="text"
                  name="sonic_other_reasons"
                  label=""
                  placeholder="オファー内容を入力"
                  style_class={styles["offer-form-input-text"]}
                  handler={handleInputChange}
                />
              </div>
              <h2 className={styles["offer-form-h2"]}>
                オファーの詳細や質問事項などあればご入力ください
              </h2>
              <FormInput
                type="textarea"
                name="sonic_message"
                label=""
                placeholder="オファーの詳細や質問事項"
                handler={handleInputChange}
              />
              <AgreementCheckBox
                value={isAgreement}
                handler={() => setIsAgreement(!isAgreement)}
              >
                <span>
                  あなたまたはオファー対象者がアカウントを削除した場合、
                  あなたのオファー情報も削除されます。
                </span>
              </AgreementCheckBox>
            </Form>
          </>
        ) : offerRequestState === OfferRequestState.offerFailed ? (
          <div className={styles["offer-failure"]}>
            <p>
              送信に失敗しました。
              <br />
              お手数ですが、再度お試しください。
            </p>
            <button type="button" onClick={handleClose}>
              閉じる
            </button>
          </div>
        ) : (
          <RequestCompleteModalBody
            handler={handleClose}
            type="オファー"
            chat_partner={ownerName}
            ownerChatDenial={ownerChatDenial}
            createRoomResult={
              offerRequestState !== OfferRequestState.chatFailed
            }
          />
        )}
      </div>
    </div>
  );
};

export default OfferModal;
